import { createContext, useContext, type ReactNode } from 'react'
import type { useNotifications } from '../hooks/useNotifications'

export type NotificationState = ReturnType<typeof useNotifications>

const NotificationContext = createContext<NotificationState>({} as NotificationState)

export function NotificationProvider({ children, notifications }: { children: ReactNode; notifications: NotificationState }) {
  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotificationContext(): NotificationState {
  return useContext(NotificationContext)
}
